import React from "react";
import Logo from "../../assets/images/logo.svg";
interface AuthPageHeaderProps {
  title: string;
  details?: string;
}

export const AuthPageHeader: React.FC<AuthPageHeaderProps> = ({
  title,
  details,
}) => (
  <div className="auth-page-header">
    {/* Logo */}
    <img src={Logo} alt="logo" className="logo" />

    <h1>{title}</h1>
    {details && <p className="details">{details}</p>}
  </div>
);
